import React from "react";
import { Badge } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import styles from "../TaskToDo/styles.module.scss";
import TaskCalendar from "@assets/icons/taskCalendar";
import Steps from "@assets/icons/steps";
import Arrow from "@assets/icons/bottomArrow";
import { SubtaskList } from "../SubtaskList";
import { Task } from "..";

export interface TaskCardProps {
  task: Task;
  isTaskDone: boolean;
  completedSubtasks: number;
  isOpen: boolean;
  onToggle: () => void;
  onToggleSubtask: (subtaskId: number) => void;
}

export const TaskCard: React.FC<TaskCardProps> = ({
  task,
  isTaskDone,
  completedSubtasks,
  isOpen,
  onToggle,
  onToggleSubtask,
}) => {
  let verticalLineHeight = 0;
  const count = task.subtasks.length;
  if (count > 0) {
    if (count === 2) {
      verticalLineHeight = 98;
    } else {
      verticalLineHeight = 39 + (count - 1) * 56;
    }
  }

  return (
    <div
      className={`${styles.taskCard} ${
        isTaskDone ? styles.doneTask : styles.newTask
      }`}
    >
      <div className={styles.timelineContainer}>
        <div
          className={styles.verticalLine}
          style={{ top: 40, height: isOpen ? verticalLineHeight : 0 }}
        />
        <div className={styles.mainCircleWrapper}>
          <div
            className={`${styles.mainCircle} ${
              isTaskDone ? styles.doneMainCircle : ""
            }`}
          >
            {isTaskDone && <CheckOutlined className={styles.checkIcon} />}
          </div>
        </div>
        <div className={styles.taskContent}>
          <div className={styles.headerBetween}>
            <div className={styles.taskHeader}>
              <div className={styles.taskTitleSection}>
                <h2
                  className={
                    isTaskDone ? styles.taskTitleDone : styles.taskTitle
                  }
                >
                  {task.title}
                </h2>
                {!isTaskDone && (
                  <span className={styles.subtasksCounter}>
                    {`${completedSubtasks}/${count}`}
                  </span>
                )}
                {task.status === "new" && (
                  <Badge
                    count={
                      <span className={styles.newBadgeContent}>
                        <span className={styles.redDot} /> New
                      </span>
                    }
                    className={styles.newBadge}
                  />
                )}
              </div>
              <div className={styles.taskMeta}>
                <span className={styles.taskDate}>
                  <TaskCalendar />
                  {task.date}
                </span>
                <span className={styles.taskSteps}>
                  <span className={styles.dot} />
                  <Steps />
                  {`${task.stepsCount} Steps`}
                </span>
              </div>
            </div>
            <button
              type="button"
              onClick={onToggle}
              className={`${styles.arrowButton} ${
                isOpen ? styles.arrowOpen : ""
              }`}
            >
              <Arrow />
            </button>
          </div>
          {isOpen && <div className={styles.taskDivider} />}
          {isOpen && count > 0 && (
            <SubtaskList
              subtasks={task.subtasks}
              isTaskDone={isTaskDone}
              onToggleSubtask={onToggleSubtask}
            />
          )}
        </div>
      </div>
    </div>
  );
};
